<template>
  <el-drawer
    title="请假申请"
    :visible.sync="drawer"
    destroy-on-close
    :modal-append-to-body="false"
    append-to-body
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'width210' : 'width54'"
  >
    <el-card class="first">
      <el-form ref="Form" :inline="true" :model="queryData" size="small">
        <Grid>
          <GridItem>
            <el-form-item label="请假类型：" prop="vacationType">
              <el-select v-model="queryData.vacationType" filterable clearable placeholder="选择请假类型">
                <el-option v-for="item in vacationTypeLists" :key="item.vacationTypeId" :label="item.vacationTypeName" :value="item.vacationTypeId" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem>
            <el-form-item label="请假状态：" prop="applyState">
              <el-select v-model="queryData.applyState" filterable clearable placeholder="选择请假状态">
                <el-option v-for="item in applyStateArr" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem>
            <el-form-item label="销假状态：" prop="retractApplyState">
              <el-select v-model="queryData.retractApplyState" filterable clearable placeholder="选择销假状态">
                <el-option v-for="item in reportBackState" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </GridItem>
          <GridItem className="grid-item-search">
            <el-form-item>
              <ELButton size="small" describe="查询" :myFunction="queryForm" type="primary" />
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </GridItem>
        </Grid>
      </el-form>
    </el-card>
    <el-card>
      <div class="pb-27">
        <el-button size="small" type="primary" @click="Add">发起审批</el-button>
      </div>
      <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="请假类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.vacationName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="开始时间" align="center" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.beginTime, scope.row.timeUnit === 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD') }}
            <span v-if="scope.row.timeUnit == 2">{{ scope.row.beginStatus === 1 ? '上午' : '下午' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" align="center" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.endTime, scope.row.timeUnit === 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD') }}
            <span v-if="scope.row.timeUnit == 2">{{ scope.row.endStatus === 1 ? '上午' : '下午' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="请假时长" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.vacationTime">{{ scope.row.vacationTime }}{{ dictType('timeUnitArr', scope.row.timeUnit) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="请假事由" align="center">
          <template slot-scope="scope">
            {{ scope.row.vacationReason || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="请假状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.applyStateStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="销假状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.cancelApplyStateStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="当前审批节点" align="center" width="200">
          <template slot-scope="scope">
            {{ scope.row.currentNode || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请日期" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" fixed="right" align="center" width="180">
          <template slot-scope="scope">
            <el-link type="primary" @click="preview(scope.row)">详情</el-link>
            <el-link v-if="scope.row.applyState === 2 || scope.row.cancelAuditState == 11" type="primary" @click="revoke(scope.row.applyOverviewId)">撤销</el-link>
            <el-link
              v-if="(scope.row.applyState === 4 || scope.row.cancelAuditState == 12) && ![4, 11].includes(scope.row.cancelAuditState)"
              type="primary"
              @click="reportBack(scope.row.applyOverviewId)"
            >
              销假
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper,sizes"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        :page-sizes="[10, 50, 100]"
        :total="total"
        @size-change="currentChange"
        @current-change="currentChange"
      />
    </el-card>
    <Add ref="Add" />
    <Revoke ref="Revoke" />
    <preview ref="Preview" />
    <ReportBack ref="ReportBack" />
  </el-drawer>
</template>

<script>
import Add from './components/Add.vue'
import ReportBack from './components/ReportBack.vue'
import Revoke from './components/Revoke.vue'
import preview from './components/preview.vue'
import { vacationTypeList } from '@/api/dropList'
import { flowVacationDetailPage, flowVacationDetailCount } from '@/api/workManage'
export default {
  components: { Add, ReportBack, Revoke, preview },
  provide() {
    return {
      indexThis: this,
    }
  },
  data() {
    return {
      drawer: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      queryData: {
        vacationType: '',
        applyState: '',
        retractApplyState: '',
      },
      vacationTypeLists: [],
      applyStateArr: [
        {
          value: 2,
          label: '审批中',
        },
        {
          value: 3,
          label: '驳回',
        },
        {
          value: 4,
          label: '审批通过',
        },
        {
          value: 12,
          label: '已撤销',
        },
      ],
      reportBackState: [
        {
          value: 11,
          label: '销假中',
        },
        {
          value: 12,
          label: '已撤销',
        },
        {
          value: 13,
          label: '拒绝销假',
        },
        {
          value: 4,
          label: '审批通过',
        },
      ],
    }
  },
  watch: {
    drawer(val) {
      if (!val) return
      this.init()
      this.vacationTypeList()
    },
  },
  methods: {
    init() {
      this.flowVacationDetailPage()
      this.flowVacationDetailCount()
    },

    async flowVacationDetailPage() {
      const { data: res } = await flowVacationDetailPage({ ...this.page, ...this.queryData, applyStaffName: this.USER_NAME })
      this.tableData = res || []
    },

    async flowVacationDetailCount() {
      const { data: total } = await flowVacationDetailCount({ ...this.page, ...this.queryData, applyStaffName: this.USER_NAME })
      this.total = parseInt(total || 0)
    },
    queryForm() {
      this.page.pageNo = 1
      this.queryData = {
        ...this.queryData,
      }
      this.init()
    },
    resetForm() {
      this.$refs.Form.resetFields()
      this.queryData = { ...this.queryData }
      this.page.pageNo = 1
      this.init()
    },
    // 获取请假类型
    async vacationTypeList(params = {}) {
      const { data: res } = await vacationTypeList(params)
      this.vacationTypeLists = res || []
    },

    // 发起审批
    Add() {
      this.$refs.Add.drawer = true
    },
    // 撤销
    revoke(id) {
      this.$refs.Revoke.addForm.flowApplyOverviewId = id
      this.$refs.Revoke.drawer = true
    },
    // 销假
    reportBack(id) {
      this.$refs.ReportBack.addForm.flowApplyOverviewId = id
      this.$refs.ReportBack.drawer = true
    },
    // 详情
    async preview(value) {
      this.$refs.Preview.getDetail(value.applyOverviewId)
      this.$refs.Preview.drawer = true
    },
    currentChange() {
      this.init()
    },
  },
}
</script>

<style lang="scss" scoped></style>
